package com.tixforgigs.common.ui.components.root


import com.tixforgigs.apax.models.Flavor
import com.tixforgigs.common.CommonBuildKonfig
import com.tixforgigs.common.core.annotations.MissingTaramiIconKey
import com.tixforgigs.common.core.annotations.MissingTaramiMessageKey
import com.tixforgigs.common.core.enums.ClientType
import com.tixforgigs.common.core.enums.View
import com.tixforgigs.common.core.extensions.BuildKonfigUtil.CONFIGURATOR_URL
import com.tixforgigs.common.core.extensions.RoutingUtil.AppScope
import com.tixforgigs.common.core.extensions.RoutingUtil.routing
import com.tixforgigs.common.core.extensions.navigateTo
import com.tixforgigs.common.core.extensions.sessionFormat
import com.tixforgigs.common.core.models.ui.MenuItem
import com.tixforgigs.common.core.theme.Styles
import com.tixforgigs.common.core.theme.TixTheme.tixThemeFlow
import com.tixforgigs.common.core.util.AuthUtil.isUserLoggedIn
import com.tixforgigs.common.core.util.CartUtil.expiresDateToLocalTimeOrNull
import com.tixforgigs.common.core.util.CartUtil.mActiveCartItemsCount
import com.tixforgigs.common.core.util.CartUtil.mCurrentOrderItemsCount
import com.tixforgigs.common.core.util.CartUtil.refresh
import com.tixforgigs.common.core.util.CartUtil.shoppingCartInvalidationFlow
import com.tixforgigs.common.core.util.LocalizationUtil.changeLocale
import com.tixforgigs.common.core.util.LocalizationUtil.currentTranslationLocale
import com.tixforgigs.common.core.util.LocalizationUtil.translationLocaleAsString
import com.tixforgigs.common.core.util.StorageUtil
import com.tixforgigs.common.core.util.StorageUtil.LocalStorageState.mShoppingCartState
import com.tixforgigs.common.core.util.StorageUtil.deleteLocalStorageItem
import com.tixforgigs.common.core.util.SupportedTranslationLanguages
import com.tixforgigs.common.core.util.ToastUtil.showSuccessToast
import com.tixforgigs.common.http.HttpClient.CLIENT_TYPE
import com.tixforgigs.common.http.HttpClient.FLAVOR
import com.tixforgigs.common.ui.components.buttons.headerIcon
import com.tixforgigs.common.ui.components.images.path
import com.tixforgigs.common.ui.components.images.svg
import com.tixforgigs.common.ui.components.menu.menuList
import com.tixforgigs.tarami.AraiMessage.textMyOrders
import com.tixforgigs.tarami.AraiMessage.textMyTickets
import com.tixforgigs.tarami.GlobalMessage.buttonLogin
import com.tixforgigs.tarami.GlobalMessage.buttonLogout
import com.tixforgigs.tarami.GlobalMessage.textFooterAbout
import com.tixforgigs.tarami.GlobalMessage.textFooterImprint
import com.tixforgigs.tarami.GlobalMessage.textFooterPrivacy
import com.tixforgigs.tarami.GlobalMessage.textFooterTermsConditions
import com.tixforgigs.tarami.GlobalMessage.textLanguageDe
import com.tixforgigs.tarami.GlobalMessage.textLanguageEn
import com.tixforgigs.tarami.GlobalMessage.textLanguageEs
import com.tixforgigs.tarami.GlobalMessage.textToastMessageSuccessfulLogout
import com.tixforgigs.tarami.GlobalMessage.titleAccount
import io.github.oshai.kotlinlogging.KotlinLogging
import io.github.oshai.kotlinlogging.logger
import io.kvision.core.Container
import io.kvision.event.clickFlow
import io.kvision.html.*
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.material.chips.assistChip
import io.kvision.material.chips.chipSet
import io.kvision.panel.simplePanel
import io.kvision.state.bind
import io.kvision.theme.Theme
import io.kvision.utils.em
import kotlinx.browser.window
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.flow.*
import kotlinx.datetime.LocalTime
import kotlin.time.Duration.Companion.seconds
import kotlin.time.ExperimentalTime


@OptIn(ExperimentalMaterialApi::class, ExperimentalTime::class)
fun Container.defaultTemplate(contentBuilder: Section.() -> Unit) {

  val log by KotlinLogging.logger()

  val countdownState: StateFlow<LocalTime?> =
    shoppingCartInvalidationFlow(
      onInvalidate = { mShoppingCartState.value?.refresh() }
    ).stateIn(
      scope = AppScope,
      started = SharingStarted.WhileSubscribed(5.seconds),
      initialValue = mShoppingCartState.value.expiresDateToLocalTimeOrNull()
    )

  val combinedFlows = combine(tixThemeFlow, currentTranslationLocale) { theme, locale ->
    theme to locale
  }.stateIn(
    scope = AppScope,
    started = SharingStarted.WhileSubscribed(5.seconds),
    initialValue = tixThemeFlow.value to currentTranslationLocale.value
  )

  header(className = Styles.MandarinClasses.HEADER) {
    simplePanel(className = "xm-header-start") {
      svg(viewBox = "0 0 256 256", className = "xm-logo") {
        path(
          d = "M0,0v256h256V0H0ZM86.488,112.035l-10.163,47.965c-1.735,7.724-5.206,11.586-12.394,11.586h-3.471c-6.816,0-10.657-4.235-9.047-11.835l10.163-47.715h-12.642c-6.816,0-10.535-3.113-10.535-7.724,0-2.367,1.116-8.222,3.965-11.088,1.86-1.87,4.091-2.865,9.793-2.865h51.186c6.816,0,10.535,3.115,10.535,7.724,0,2.367-1.116,8.222-3.967,11.088-1.859,1.87-4.089,2.865-9.791,2.865h-13.634ZM139.285,120.134l-7.312,34.012c-1.611,7.35-.372,10.216,4.089,11.586.124.124-1.735,6.727-13.014,6.727-14.004,0-16.855-8.47-14.624-19.186l7.064-33.139c1.736-8.596,4.835-11.461,10.907-11.461h2.479c6.446,0,12.269,2.615,10.411,11.461ZM133.211,102.194c-7.806,0-12.394-4.111-12.394-9.842,0-7.724,5.578-12.707,13.138-12.707,7.808,0,12.394,4.111,12.394,9.842,0,7.724-5.578,12.707-13.138,12.707ZM210.784,131.097l-14.502,11.959,2.232,4.983c3.469,8.472,7.808,9.594,12.145,9.844.744.124-1.24,14.077-14.996,14.077-5.95,0-12.023-2.367-15.244-13.829l-1.736-5.981-19.458,20.184c-.248.374-12.642-3.115-12.642-12.085,0-4.359,2.479-7.848,6.816-11.212l13.758-11.212-11.031-23.049c-.372-.872,5.578-6.479,14.5-6.479,6.57,0,9.172,3.613,11.279,10.964l3.347,9.094,19.582-20.556c.372-.25,12.766,3.113,12.766,12.083,0,4.361-2.603,7.974-6.816,11.214Z",
          color = "currentColor"
        )
      }
      if (FLAVOR != Flavor.PROD) {
        div(className = "xm-ribbon") {
          setAttribute("data-text", FLAVOR.name)
        }
      }
    }.clickFlow.onEach {
      routing.navigateTo(View.RELATIVE_BASE_PATH_ROOT)
    }.launchIn(MainScope())

    div(className = "xm-actions") {
      /*simplePanel().bind(countFlow) { count ->
        if (count != null) {
          chipSet {
            @MissingTaramiMessageKey
            assistChip(className = "xm-count", label = "USERS: ${count.count}") {
              fontSize = .22.em
              padding = .01.em
            }
          }
        }
      }*/
      div(className = "xm-actions-content").bind(isUserLoggedIn) { loggedIn ->


        simplePanel().bind(countdownState) { expiresTime ->
          expiresTime?.let { time ->
            chipSet {
              assistChip(className = "xm-timer", label = time.sessionFormat()) {
                fontSize = .22.em
                padding = .01.em
              }
            }
          }
        }

        simplePanel().bind(mCurrentOrderItemsCount) { count ->
          if (count > 0) {
            @MissingTaramiMessageKey
            @MissingTaramiIconKey
            headerIcon(
              icon = "inactive_order",
              label = "Last Order",
              badge = mCurrentOrderItemsCount,
              onClick = {
                routing.navigateTo(View.PAYMENT_RESTART)
              }
            )
          }
        }

        simplePanel().bind(mActiveCartItemsCount) { count ->
          if (count > 0) {
            @MissingTaramiMessageKey
            @MissingTaramiIconKey
            headerIcon(
              icon = "local_activity",
              label = "Shopping Cart",
              badge = mActiveCartItemsCount,
              onClick = {
                routing.navigateTo(View.PAYMENT_START)
              }
            )
          }
        }

        simplePanel().bind(combinedFlows) { (theme, locale) ->
          val menuList = mutableListOf<MenuItem>()
          if (loggedIn) {
            if (CLIENT_TYPE == ClientType.ARAI_STOREFRONT) {
              menuList.addAll(
                elements = listOf(
                  @MissingTaramiIconKey
                  MenuItem(
                    text = titleAccount(),
                    leadingIcon = "account_circle",
                    onClick = {
                      routing.navigateTo(View.ACCOUNT)
                    }
                  ),
                  @MissingTaramiIconKey
                  MenuItem(
                    text = textMyTickets(),
                    leadingIcon = "local_activity",
                    onClick = {
                      routing.navigateTo(View.ACCOUNT_TICKETS)
                    }
                  ),
                  @MissingTaramiIconKey
                  MenuItem(
                    text = textMyOrders(),
                    leadingIcon = "receipt",
                    onClick = {
                      routing.navigateTo(View.ORDERS)
                    }
                  )
                )
              )
            }
            menuList.add(
              @MissingTaramiIconKey
              MenuItem(
                text = buttonLogout(),
                leadingIcon = "logout",
                onClick = {
                  deleteLocalStorageItem(StorageUtil.StorageKey.AuthToken)
                  when (CLIENT_TYPE) {
                    ClientType.ARAI_STOREFRONT -> routing.navigateTo(View.EVENTS)
                    ClientType.TEMPLATE_CONFIGURATOR -> routing.navigateTo(View.LOGIN)
                  }
                  showSuccessToast(
                    message = textToastMessageSuccessfulLogout()
                  )
                }
              )
            )
          } else {
            menuList.add(
              @MissingTaramiIconKey
              MenuItem(
                text = buttonLogin(),
                leadingIcon = "account_circle",
                onClick = {
                  routing.navigateTo(View.LOGIN)
                }
              )
            )
          }
          menuList.addAll(
            elements = listOf(
              @MissingTaramiMessageKey
              @MissingTaramiIconKey
              MenuItem(
                text = "Dark / Light Mode",
                leadingIcon = "contrast",
                subMenu = listOf(
                  @MissingTaramiMessageKey
                  @MissingTaramiIconKey
                  MenuItem(
                    text = "heller Modus",
                    leadingIcon = "light_mode",
                    trailingIcon = if (theme == Theme.LIGHT) "check" else null,
                    onClick = {
                      tixThemeFlow.update { Theme.LIGHT }
                    }
                  ),
                  @MissingTaramiMessageKey
                  @MissingTaramiIconKey
                  MenuItem(
                    text = "dunkler Modus",
                    leadingIcon = "dark_mode",
                    trailingIcon = if (theme == Theme.DARK) "check" else null,
                    onClick = {
                      tixThemeFlow.update { Theme.DARK }
                    }
                  ),
                  @MissingTaramiMessageKey
                  @MissingTaramiIconKey
                  MenuItem(
                    text = "Systemeinstellungen übernehmen",
                    trailingIcon = if (theme == Theme.AUTO) "check" else null,
                    onClick = {
                      tixThemeFlow.update { Theme.AUTO }
                    }
                  )
                )
              ),
              @MissingTaramiMessageKey
              @MissingTaramiIconKey
              MenuItem(
                text = "Sprache",
                leadingIcon = "language",
                subMenu = listOf(
                  @MissingTaramiIconKey
                  MenuItem(
                    text = textLanguageDe(),
                    trailingIcon = if (locale == SupportedTranslationLanguages.DE.locale) "check" else null,
                    onClick = {
                      changeLocale(SupportedTranslationLanguages.DE)
                    }
                  ),
                  @MissingTaramiIconKey
                  MenuItem(
                    text = textLanguageEn(),
                    trailingIcon = if (locale == SupportedTranslationLanguages.EN.locale) "check" else null,
                    onClick = {
                      changeLocale(SupportedTranslationLanguages.EN)
                    }
                  ),
                  @MissingTaramiIconKey
                  MenuItem(
                    text = textLanguageEs(),
                    trailingIcon = if (locale == SupportedTranslationLanguages.ES.locale) "check" else null,
                    onClick = {
                      changeLocale(SupportedTranslationLanguages.ES)
                    }
                  ),
                )
              )
            )
          )
          when (FLAVOR) {
            Flavor.LOCAL, Flavor.DEV -> {
              menuList.add(
                MenuItem(
                  text = "LOCAL/DEV Optionen",
                  leadingIcon = "lab_research",
                  subMenu = when (CLIENT_TYPE) {
                    ClientType.ARAI_STOREFRONT -> listOf(
                      @MissingTaramiMessageKey
                      @MissingTaramiIconKey
                      MenuItem(
                        text = "Warenkorb / Bestellung lokal löschen",
                        leadingIcon = "delete_forever",
                        onClick = {
                          deleteLocalStorageItem(StorageUtil.StorageKey.ShoppingCart)
                          deleteLocalStorageItem(StorageUtil.StorageKey.CurrentOrderMetadata)
                          deleteLocalStorageItem(StorageUtil.StorageKey.CurrentOrder)
                        }
                      ),
                      @MissingTaramiMessageKey
                      @MissingTaramiIconKey
                      MenuItem(
                        text = "Präferierte Sprache löschen",
                        leadingIcon = "delete_forever",
                        onClick = {
                          deleteLocalStorageItem(StorageUtil.StorageKey.UserLocale)
                        }
                      ),
                      @MissingTaramiMessageKey
                      @MissingTaramiIconKey
                      MenuItem(
                        text = "Template Konfigurator öffnen",
                        leadingIcon = "settings",
                        onClick = {
                          window.open(CONFIGURATOR_URL)
                        }
                      ),
                      @MissingTaramiMessageKey
                      @MissingTaramiIconKey
                      MenuItem(
                        text = "Test Einbettungen",
                        leadingIcon = "iframe",
                        subMenu = listOf(
                          @MissingTaramiMessageKey
                          @MissingTaramiIconKey
                          MenuItem(
                            text = "Einbettung Test 01",
                            leadingIcon = "iframe",
                            onClick = {
                              window.open("https://dev.embed.tixforgigs.tv/E01.html", "_blank")
                            }
                          ),
                          @MissingTaramiMessageKey
                          @MissingTaramiIconKey
                          MenuItem(
                            text = "Einbettung Test 02",
                            leadingIcon = "iframe",
                            onClick = {
                              window.open("https://dev.embed.tixforgigs.tv/E02.html", "_blank")
                            }
                          ),
                          @MissingTaramiMessageKey
                          @MissingTaramiIconKey
                          MenuItem(
                            text = "Einbettung Test 03",
                            leadingIcon = "iframe",
                            onClick = {
                              window.open("https://dev.embed.tixforgigs.tv/E03.html", "_blank")
                            }
                          ),
                          @MissingTaramiMessageKey
                          @MissingTaramiIconKey
                          MenuItem(
                            text = "Einbettung Test 04",
                            leadingIcon = "iframe",
                            onClick = {
                              window.open("https://dev.embed.tixforgigs.tv/E04.html", "_blank")
                            }
                          )
                        )
                      )
                    )

                    ClientType.TEMPLATE_CONFIGURATOR -> listOf(
                      @MissingTaramiMessageKey
                      @MissingTaramiIconKey
                      MenuItem(
                        text = "Mandarin Farbübersicht",
                        leadingIcon = "palette",
                        onClick = {
                          routing.navigateTo(View.EXAMPLE)
                        }
                      )
                    )
                  }
                )
              )
            }

            else -> Unit
          }
          menuList(menuList)
        }
      }
    }
  }

  section(
    className = Styles.MandarinClasses.SECTION,
    init = contentBuilder
  )

  footer(className = Styles.MandarinClasses.FOOTER) {

    div(className = "xm-footer-info") {
      div(className = "xm-footer-links") {
        ul {
          li {
            link(
              label = textFooterAbout(),
              target = "_blank",
              url = "https://www.tixforgigs.com/Home/Company"
            )
          }
        }
      }
      div(className = "xm-footer-links") {
        ul {
          li {
            link(
              label = textFooterImprint(),
              target = "_blank",
              url = "https://redesign.tixforgigs.com/frontend/$translationLocaleAsString/Home/About"
            )
          }
        }
      }
      div(className = "xm-footer-links") {
        ul {
          li {
            link(
              label = textFooterPrivacy(),
              target = "_blank",
              url = "https://redesign.tixforgigs.com/frontend/$translationLocaleAsString/Home/Privacy"
            )
          }
        }
      }
      div(className = "xm-footer-links") {
        ul {
          li {
            link(
              label = textFooterTermsConditions(),
              target = "_blank",
              url = "https://redesign.tixforgigs.com/frontend/$translationLocaleAsString/Home/GeneralTermsAndConditions"
            )
          }
        }
      }

    }
    div(className = "xm-legal-info") {
      small(className = "extra copy", content = "©")
      time(className = "year", datetime = "${CommonBuildKonfig.BUILD_TIMESTAMP.subSequence(0, 4)}")
      small(className = "extra", content = "TixforGigs / Fluffy Clouds GmbH & Co. KG, Leipzig. All Rights Reserved.")
      small(className = "extra", content = " Made with")
      small(className = "emoji", content = "❤\uFE0E ")
      small(className = "extra", content = "in Saxony.")
    }

    div(className = "xm-app-info") {
      small("API VERSION: ${CommonBuildKonfig.API_VERSION}")
      small("APP VERSION: ${CommonBuildKonfig.CLIENT_VERSION}")
      small("BUILD: ${FLAVOR.name.uppercase()} / ${CommonBuildKonfig.BUILD_TIMESTAMP}")
    }

  }
}
